import React, { useEffect } from "react";
import { ValidationHeader } from "../validation-header";
import { ValidationForm } from "../validation-form";
import { useBiller } from "hooks";
import { useSelector } from "react-redux";
import { getBillerLoadStatus } from "selectors";
import { EMPTY, IN_PROGRESS, ERROR } from "constants/Status";
import { IContactInfo, IImageResources } from "types/biller";
import { Spinner } from "kubra-ux-forge";
import { ContactAndTocFooter } from "components/ezpay/common/contact-and-toc-footer";
import { useNavigate } from "react-router-dom";
import routing from "routing";

export const ValidationContainer = () => {

  const { loadBiller, getBiller } = useBiller();
  const loadBillerStatus = useSelector(getBillerLoadStatus);
  const biller = getBiller();
  const navigate = useNavigate();

  useEffect(() => {
    loadBiller();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (loadBillerStatus === ERROR) {
      console.log("failed to retrieve instance");
      navigate(routing.notFound.index());
    }
  }, [loadBillerStatus, navigate]);

  if (!biller || loadBillerStatus === EMPTY || loadBillerStatus === IN_PROGRESS) {
    return (
      <div className="validate-frame">
        <div className="validate-content">
          <Spinner size="large" variant="primary" />
        </div>
      </div>
    );
  }

  // get required values from subresources
  const imageResources = biller.properties?.find((element) => {
    return element.name === "ImageResources";
  }) as IImageResources;

  const contactUs = biller.properties?.find((element) => {
    return element.name === "InstanceConfiguration";
  }) as IContactInfo;

  return (
    <div>
      <div className="validate-frame">
        <ValidationHeader
          logoUrl={imageResources?.properties?.logoURL ?? ""}
          billerUrl={contactUs?.properties?.website ?? ""}
        />
        <ValidationForm
          validationFields={biller.validationFields}
          billerId={biller.billerName ?? ""}
          instanceId={biller.instanceId ?? ""}
          billImage={imageResources?.properties?.billSampleURL ?? ""}
          accountPlaceholder={biller.accountPlaceholder ?? "xxxxxxxxxx"}
          vcodePlaceholder={biller.vcodePlaceholder ?? "xxxxx"}
          spaceKrn={biller.spaceKrn ?? ""}
          accountV2={biller?.featureFlags?.accountV2}
        />
        <ContactAndTocFooter biller={biller} />
      </div>
    </div>
  );
};
